export default __webpack_public_path__ + "static/sirio-1-a3bc75c5a5860288bbcfe61d26bbe924.jpg";